import React from "react";
import { Row, Col, Typography, Button } from "antd";
import { Link } from "react-router-dom";
import { Event } from "@bindeleddet/core/types";
import EventCardMobile from "./EventCardMobile/EventCardMobile";

const { Text } = Typography;

interface HeroMobileProps {
  upcomingEvents: Event[] | undefined;
}

const HeroMobile: React.FC<HeroMobileProps> = ({ upcomingEvents }) => {
  return (
    <Row justify="center" gutter={[0, 16]} style={{ paddingTop: "2em" }}>
      <Col span={24} style={{ textAlign: "center" }}>
        <Text style={{ color: "#DDEDEA", opacity: "70%" }}>Kommende arrangementer</Text>
      </Col>
      <Col span={24}>
        <Row gutter={[0, 16]}>
          {upcomingEvents?.length === 0 ? (
            <Col span={24} style={{ textAlign: "center" }}>
              <Text italic style={{ color: "white", fontSize: "1.2em" }}>
                Ingen arrangementer i nærmeste fremtid...
              </Text>
            </Col>
          ) : (
            <>
              {upcomingEvents?.slice(0, 4).map(event => (
                <Col span={24} key={event.id}>
                  <EventCardMobile event={event} />
                </Col>
              ))}
              <Col span={24} style={{ textAlign: "center" }}>
                <Link to="/events/">
                  <Button size="large" type="primary" style={{ backgroundColor: "#1B374D" }}>
                    Flere arrangementer &gt;
                  </Button>
                </Link>
              </Col>
            </>
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default HeroMobile;
